import { useState } from 'react'
import { Dialog, Drawer, type DialogContentProps, type DialogProps } from '@/components/play'
import { useWatchLayout } from '@/lib/watch/useMediaQuery'
import './sign-in.css'

export type WatchSheetProps = DialogContentProps & Pick<DialogProps, 'initialFocus' | 'finalFocus'> & {
  open: boolean
  /** Close, Escape, the backdrop or (on phones) a swipe down ask to close with `false`. */
  onOpenChange: (open: boolean) => void
  /** Classes for the surface. */
  className?: string
}

/**
 * A short task over the watch screen, such as signing in: a Play Drawer from the bottom on a phone (upright or on its
 * side, as the page's layout), a Dialog on the desktop. Its body unmounts when it closes, so the next opening starts
 * fresh. The layout holds while it is open: swapping Drawer for Dialog would remount the body, so a phone rotating past
 * the breakpoint would lose what was typed or a link already sent. It follows the screen again once closed.
 */
export function WatchSheet({ open, onOpenChange, className, ...content }: WatchSheetProps) {
  const live = useWatchLayout() !== 'desktop'
  const [held, setHeld] = useState(live)
  if (!open && held !== live) setHeld(live)
  const phone = open ? held : live
  return phone
    ? <Drawer side="bottom" open={open} onOpenChange={onOpenChange} className={className} {...content} />
    : <Dialog open={open} onOpenChange={onOpenChange} className={className} {...content} />
}
